<template>
  <div class="container article">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长</el-breadcrumb-item>
        <el-breadcrumb-item>学长经验</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">学长经验</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleToCategory">分类管理</el-button>
          <el-button class="button"
                     type="primary"
                     @click="handleArticelCreate">发布文章</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="文章名称"
                      prop="name">
          <el-input v-model="query.keyword"
                    placeholder="输入文章名称"
                    @input="fetchArticleList(true)"
                    clearable></el-input>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="fetchArticleList(true)"
                          :style="{ width: isfixed ? '400px' : '260px' }"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="院校"
                      prop="college">
          <el-select v-model="query.college_code"
                     filterable
                     placeholder="请选择"
                     @change="fetchArticleList(true)"
                     clearable>
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类"
                      prop="category_id">
          <el-select v-model="query.category_id"
                     placeholder="请选择"
                     @change="fetchArticleList(true)"
                     clearable>
            <el-option v-for="item in categorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学长搜索"
                      prop="name">
          <el-input v-model="query.author"
                    placeholder="输入学长手机号，真实姓名"
                    style="width: 300px"
                    @input="fetchCourseList(true)"
                    clearable></el-input>
        </el-form-item>
        <!--       <el-form-item label="钉钉推送状态">
          <el-select
            v-model="query.is_ding_push"
            placeholder="请选择"
            @change="fetchArticleList(true)"
            clearable
          >
            <el-option
              label="已推送"
              :value="1"
            >
            </el-option>
            <el-option
              label="未推送"
              :value="0"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="数据是否完整">
          <el-select v-model="query.is_data_complete"
                     placeholder="请选择"
                     @change="fetchArticleList(true)"
                     clearable>
            <el-option label="完整"
                       :value="1"> </el-option>
            <el-option label="不完整"
                       :value="0"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序方式">
          <el-select v-model="query.sort_type"
                     placeholder="请选择"
                     @change="fetchArticleList(true)"
                     clearable>
            <el-option label="发布时间倒序"
                       :value="0"> </el-option>
            <el-option label="创建时间倒序"
                       :value="1"> </el-option>
            <el-option label="更新时间倒序"
                       :value="2"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">文章列表</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="query.audit_statuses"
                            @change="fetchArticleList(true)">
              <el-radio-button v-for="(item, index) in filter.type"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="tabs">
        <el-tabs
          v-model="tabName"
          @tab-click="handleTabChange"
        >
          <el-tab-pane
            label="全部商品"
            name="all"
          ></el-tab-pane>
          <el-tab-pane
            label="学长商品"
            name="senior"
          ></el-tab-pane>
        </el-tabs>
      </div> -->
      <div class="values">
        <el-table :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           width="80"
                           label="ID"
                           align="center">
          </el-table-column>
          <el-table-column label="发布学长"
                           width="180"
                           align="center"
                           v-if="query.is_author == 1"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.author">{{ scope.row.author.realname }}/{{
                  scope.row.author.mobile
                }}</span></template>
          </el-table-column>
          <el-table-column prop="title"
                           width="400"
                           label="标题"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="分类"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateCategory_id(scope.row.category_id) }}
            </template>
          </el-table-column>

          <!--         <el-table-column
            width="100"
            label="钉钉推送状态"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.is_ding_push?'已推送':'未推送'}}
            </template>
          </el-table-column> -->

          <!--     <el-table-column
            prop="service"
            label="描述"
            width="300"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div class="item-table-column">
                {{ scope.row.description }}
              </div>      
            </template>
          </el-table-column> -->

          <el-table-column prop="pv"
                           label="浏览量"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.pv - scope.row.virtual_pv }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="comment_extend_comment_count"
                           label="评论数"
                           align="center">
            <template slot-scope="scope">
              <span style="font-size: 14px; color: #409eff;  cursor: pointer;"
                    @click="handleComment(scope.row)">{{scope.row.comment_extend_comment_count ? scope.row.comment_extend_comment_count : 0}}条</span>
            </template>
          </el-table-column>
          <el-table-column label="发布日期"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.publish_time
                  ? $moment(scope.row.publish_time).format("YYYY-MM-DD")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column label="更新日期"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.update_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="状态"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="small"
                      :type="scope.row.status == 1 ? 'success' : 'danger'">{{ scope.row.status == 1 ? "上架" : "下架" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column width="100"
                           label="文章是否完整"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.is_data_complete ? "完整" : "不完整" }}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="200"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-link v-if="scope.row.audit_status==0"
                       type="warning"
                       :underline="false"
                       @click="goAudit(scope.row)">审核</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="goDetail(scope.row)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToPreview(scope.row)">浏览</el-link>
              <!--     <el-link
                type="primary"
                :underline="false"
                @click="handleToClone(scope.row.id)"
              >复制</el-link> -->
              <!-- <el-link
                type="primary"
                :underline="false"
                @click="handleToOrigin(scope.row)"
                >原文链接</el-link
              > -->
              <el-link type="danger
            "
                       @click="handleArticleRemove(scope.row.id)"
                       :underline="false">删除</el-link>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link"> ... </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom: 6px"><span @click="goDetail(scope.row)"
                          style="font-size: 16px; color: #409eff">
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item command="b"
                                    style="margin-bottom: 6px"><span @click="handleToPreview(scope.row)"
                          style="font-size: 16px; color: #409eff">
                      浏览
                    </span></el-dropdown-item>
                  <el-dropdown-item command="c"
                                    style="margin-bottom: 6px"><span @click="handleToClone(scope.row.id)"
                          style="font-size: 16px; color: #409eff">
                      复制
                    </span></el-dropdown-item>
                  <el-dropdown-item command="d"
                                    style="margin-bottom: 6px"><span @click="handleArticleRemove(scope.row.id)"
                          style="font-size: 16px; color: #f56c6c">
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <ChangeTagsReal @close="editDialog = false"
                    :visible="editDialog"
                    @submit="fetchArticleList()"
                    :content="editContent" />
    <el-dialog title="评论列表"
               :visible.sync="commentShow"
               width="50%">
      <el-table :data="commentResult"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                :default-expand-all="false"
                @expand-change="handleExpand"
                :tree-props="{children: 'children'}">
        <el-table-column prop="id"
                         label="ID"
                         align="center"
                         width="90">
        </el-table-column>
        <el-table-column label="发布人"
                         width="170"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.create_user_obj.nickname }}/{{scope.row.create_user_obj.mobile}}</span></template>
        </el-table-column>
        <el-table-column label="评论内容"
                         width="200"
                         align="left"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span></template>
        </el-table-column>
        <el-table-column label="评论对象"
                         width="170"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.replyed_user_obj">{{ scope.row.replyed_user_obj.nickname }}/{{scope.row.replyed_user_obj.mobile}}</span>
            <span v-else>经验</span>
          </template>
        </el-table-column>
        <el-table-column label="点赞数"
                         width="80"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.like_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间"
                         align="center"
                         width="200"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD")
                  : ""
              }}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="100"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="commentDetle(scope.row)"><span class="cao">删除</span></el-link>
          </template>
        </el-table-column>

      </el-table>
      <div style="display:flex;justify-content:center; ">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(commentQuery.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(commentQuery.pageSize)"
                       :total="Number(commentTotal)"
                       @size-change="handleSizeComment"
                       @current-change="handlePageComment">
        </el-pagination>

      </div>

    </el-dialog>

    <el-dialog title="审核"
               :visible.sync="auditShow"
               width="30%">
      <el-radio-group v-model="auditRadio">
        <el-radio :label="1">通过</el-radio>
        <el-radio :label="2">驳回</el-radio>
      </el-radio-group>
      <el-form ref="form"
               label-width="70px"
               v-if="auditRadio == 2"
               style="margin-top:20px">
        <el-form-item label="驳回理由">
          <el-input type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="rejection">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="auditShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="auditSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ArticleCard from '@/components/card/Article'
import ChangeTagsReal from '@/components/dialog/article/ChangeTagsReal'
import {
  articleList,
  articleDestroy,
  articleCategoryList,
  articleClone,
  auditStatus,
} from '@/api/article'
import { levelOneList, twoList, deleteComment } from '@/api/senior'

export default {
  components: {
    ArticleCard,
    ChangeTagsReal,
  },
  data() {
    return {
      id: '',
      auditRadio: 1,
      auditShow: false,
      commentShow: false,
      rejection: '',
      createDialog: false,
      query: {
        name: '',
        author: '',
        startTime: '',
        endTime: '',
        subject: '',
        status: '',
        audit_statuses: 0,
        sort: '1',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        sort_type: 0,
        is_author: 1,
      },
      commentQuery: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
      },
      createDatetime: '',
      pageTotal: 10,
      commentTotal: 10,
      filter: {
        type: [
          { label: '已通过', value: '1' },
          { label: '审核中', value: '0' },
          { label: '未通过', value: '-1' },
        ],
        status: [
          { label: '全部', value: '' },
          { label: '上架', value: '1' },
          { label: '下架', value: '0' },
        ],
        sorts: [
          { label: '最新', value: '1' },
          { label: '最热', value: '2' },
        ],
      },
      categorys: [],
      results: [],
      isfixed: document.body.clientWidth < 820 ? false : true,
      tabName: '',
      editContent: {},
      editDialog: false,
      commentResult: [],
      clickRow: {},
      twoId: {},
    }
  },
  created() {
    this.parseQuery()
    this.fetchCategoryList()
    this.fetchArticleList()
    this.$store.dispatch('getAllColleges')
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  methods: {
    handleExpand(val) {
      console.log('zhankai', val)
      this.twoId = val
      this.twoComment()
    },
    //获取一级二级评论
    handleComment(row) {
      this.commentShow = true
      this.clickRow = row
      this.oneComment()
    },
    oneComment() {
      let data = {
        pageSize: this.commentQuery.pageSize,
        pageIndex: this.commentQuery.pageIndex,
        article_id: this.clickRow.id,
      }
      levelOneList(data).then((res) => {
        res.list.map((item) => {
          item.children = []
          if (item.level_one_first_row) {
            item.children.push(item.level_one_first_row)
          }
        })
        this.commentTotal = res.count
        this.commentResult = res.list.sort(
          (a, b) => b.create_time - a.create_time
        )
      })
    },
    //获取二级评论列表
    twoComment() {
      let data = {
        isPaging: 0,
        parent_level_one_id: this.twoId.id,
      }
      twoList(data).then((res) => {
        this.commentResult.map((v) => {
          if (v.id == res.list[0].parent_level_one_id) {
            v.children = res.list.sort((a, b) => b.create_time - a.create_time)
          }
        })
      })
    },
    commentDetle(row) {
      console.log('评论删除', row)
      this.$confirm('确定要删除当前评论吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = []
        ids.push(row.id)
        deleteComment({
          ids: ids,
        }).then((res) => {
          this.$message.success('删除成功')
          this.oneComment()
          this.fetchArticleList()
        })
      })
    },
    goAudit(row) {
      this.id = row.id
      this.auditShow = true
    },
    auditSubmit() {
      if (this.auditRadio == 1) {
        auditStatus({
          id: this.id,
          audit_status: 1,
        }).then((res) => {
          this.fetchArticleList()
          this.auditShow = false
          this.$message.success('审核成功!')
        })
      } else if (this.auditRadio == 2) {
        if (!this.rejection) {
          this.$message.error('请输入驳回理由')
          return false
        }

        auditStatus({
          id: this.id,
          audit_status: -1,
          refuse_reason: this.rejection,
        }).then((res) => {
          this.fetchArticleList()
          this.auditShow = false
          this.$message.success('审核成功!')
        })
      }

      //   console.log("xxx", this.auditRadio);
    },
    // 文章列表请求
    fetchArticleList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      this.query.is_author = 1
      articleList(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分类列表请求
    fetchCategoryList() {
      articleCategoryList({ isPaging: 0 }).then((res) => {
        this.categorys = res.list
      })
    },
    // 检索条件变化
    handleFilterChange(value, type) {
      if (type === 'sort') {
        this.query.sort = value
      }
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchArticleList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchArticleList()
    },
    handleSizeComment(val) {
      this.$set(this.commentQuery, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.oneComment()
    },
    handlePageComment(val) {
      this.$set(this.commentQuery, 'pageIndex', val)
      this.oneComment()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchArticleList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchArticleList()
      }, 20)
    },
    // 分类管理
    handleToCategory() {
      this.$router.push(`/article/category`)
    },
    // 文章创建
    handleArticelCreate() {
      this.$router.push(`/article/create`)
    },
    // 文章删除
    handleArticleRemove(materialId) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          articleDestroy({ id: materialId }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchArticleList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
      if (this.query.sort_type) {
        this.query.sort_type = Number(this.query.sort_type)
      }
      //   this.tabName = this.query.is_author == 1 ? "senior" : "all"
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    formateCategory_id(id) {
      if (this.categorys.length && id) {
        return this.categorys.find((v) => {
          return v.id == id
        }).name
      }
    },
    // 表格操作跳转页面
    goDetail(item) {
      this.$router.push(`/senior/edit/${item.id}`)
      // this.$router.push(`/article/edit/${item.id}`);
    },
    // 预览
    handleToPreview(item) {
      if (item) {
        if (location.host.includes('admin.kaoyanbox.com')) {
          window.open(`https://h5.kaoyanbox.com/article/detail/${item.id}`)
        } else {
          window.open(`http://h5.kaoyanbox.net/article/detail/${item.id}`)
        }
      }
    },
    handleToClone(id) {
      // 二次确认
      this.$confirm('确定要复制吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          articleClone({ id: id }).then((res) => {
            this.$message.success(`复制成功，请在下架列表中查看`)
            this.fetchArticleList()
          })
        })
        .catch(() => {})
    },
    handleTabChange(tab) {
      if (tab.name == 'senior') {
        this.query.is_author = 1
      } else {
        this.query.is_author = 0
      }
      this.fetchArticleList(true)
    },
    changeTags_real(row) {
      this.editContent = Object.assign({}, row)
      this.editDialog = true
    },
    handleToOrigin(row) {
      if (row.origin_url) {
        window.open(row.origin_url)
      } else {
        this.$message.error('暂无原文链接')
      }
    },
  },
}
</script>

<style scoped lang="less">
.article {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
.tag-wrap {
  text-align: left;
  width: 100%;
  min-height: 30px;
}
.el-tag {
  margin: 0px 5px;
}
</style>
